import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { Icon20, Icon24 } from 'cio-design-library/icons'

import Typography, { FontWeights } from 'builder/styles/typography'
import Button from 'builder/components/Button'
import Media from 'builder/styles/media'

export const ItemContainer = styled.div`
  display: flex;
  padding: ${Spacing.S} 20px;
  border-radius: 4px;
  border: 1px solid ${Colors.Neutral15};
  flex-direction: column;
`

export const ItemTextContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ItemBeforeAfter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  margin-top: 12px;
`

export const ItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  & path {
    stroke: ${Colors.Neutral50};
  }
`

export const ItemTitle = styled.div`
  color: ${Colors.Neutral90};
  ${Typography.Body};
  ${FontWeights.Medium};
`

export const ItemValue = styled.div`
  color: ${Colors.Neutral50};
  ${Typography.Caption};
  ${FontWeights.Regular};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.XS};
  padding: 0 ${Spacing.S} ${Spacing.S} ${Spacing.S};
  overflow: auto;
  ${Media.Tablet`
    padding: 0 20px 16px 20px;
    max-height: 80vh;
  `}
  ${Media.AboveTablet`
    height: 100%;
  `}
`

export const BeforeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: inherit;
  gap: 6px;
`

export const Title = styled.div`
  ${Typography.Caption};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
`

export const ContentBefore = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const AfterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: inherit;
  gap: 6px;
`

export const SkillsBeforeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

export const SkillBeforeItem = styled.p`
  font-size: 19px;
  line-height: 22px;
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const SkillsAfterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

export const SkillAfterItemButton = styled(Button)`
  font-size: 19px;
  line-height: 22px;
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
  border-radius: ${Spacing['4XS']};
  background: ${Colors.Neutral10};
  padding: 4px 8px;
  cursor: pointer;
  gap: 10px;
  &:hover,
  &:focus-visible,
  &:active {
    background: ${Colors.Blue10};
    color: ${Colors.Blue50};
  }
`

export const CloseIcon = styled(Icon20.Close)`
  width: 20px;
  height: 20px;
  color: inherit;
`

export const WorkExperienceContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`

export const WorkExperienceWrapper = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${Colors.Neutral15};
  border-radius: 4px;
  padding: 16px 20px;
  gap: ${props => (props.isOpen ? '16px' : '0')};
`

export const WorkExperienceHeader = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: ${props => (props.isOpen ? 'pointer' : 'unset')};
`
export const WorkExperienceTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const WorkExperienceTitle = styled.p`
  ${Typography.Caption};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
`

export const WorkExperienceDate = styled.p`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const EditIcon = styled(Icon24.EditAlt)`
  cursor: pointer;
  color: ${Colors.Blue50};
`

export const WorkExperienceContent = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: ${props => (props.isOpen ? 'auto' : '0')};
  overflow: ${props => (props.isOpen ? 'visible' : 'hidden')};
  opacity: ${props => (props.isOpen ? '1' : '0')};
  transition: height 200ms ease, opacity 200ms ease;
`

export const WorkExperienceTextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['3XS']};
`

export const TextAreaDescription = styled.p`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const ItemWrapper = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
`
